import React, {Fragment, FunctionComponent} from "react";
import {IconButtonSkeleton} from "@App/Components/common/IconButton/IconButtonSkeleton";
import {useTranslation} from "react-i18next";
import {bindActionCreators} from "@reduxjs/toolkit";
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from "@App/state";
import {MileageInput} from "@App/Components/common/MileageInput";

type MileageStepProps = {
    loading: boolean
    error: any
    nextStep: any
};

export const MileageStep: FunctionComponent<MileageStepProps> = (props: MileageStepProps)  => {

    const {t} = useTranslation()

    const dispatch = useDispatch();
    const {setMileage} = bindActionCreators(actionCreators, dispatch)
    const mileage = useSelector((state: State) => state.orders.mileage)


    return (
        <Fragment>
            {props.loading && (
                <div className="overflow-hidden">
                    <div
                        className={`md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full`}>
                        <IconButtonSkeleton/>
                        <IconButtonSkeleton/>
                        <IconButtonSkeleton/>
                        <IconButtonSkeleton/>
                    </div>
                </div>
            )}
            {props.error && (
                <div>
                    {t('error')}
                </div>
            )}
            {!props.loading && (
                <div className="overflow-hidden">
                    <MileageInput value={mileage}
                                  onChange={setMileage}
                                  placeholder="30.000"
                                  className="w-fit"/>
                </div>
            )}

            <div
                onClick={props.nextStep}
                className={``}>
                <div
                    className={`bg-primary w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline`}>
                    {t('weiter')}
                </div>
            </div>
        </Fragment>
    )
}
